export default function buildExampleScript ({
  organizationName,
  domainName,
  commandName
}: { organizationName: string, domainName: string, commandName: string }) {
  return `#!/usr/bin/env ruby

require "bundler/setup"

require "foobara/load_dotenv"
Foobara::LoadDotenv.run!(dir: __dir__)

require "foobara/remote_imports"

Foobara::RemoteImports::ImportCommand.run!(
  manifest_url: "https://app.commandforge.com/run/GetManifestForDomain?domain=${organizationName}::${domainName}}",
  auth_header: ["x-api-key", -> { ENV.fetch("COMMANDFORGE_API_KEY") }],
  manifest_requires_auth: true,
  cache: false # remove this if you want to skip checking for changes
)

# Call it directly:
# puts ${organizationName}::${domainName}::${commandName}.run!(inputs)

# or expose it with a connector, such as a CLI connector here:
require "foobara/sh_cli_connector"

connector = Foobara::CommandConnectors::ShCliConnector.new
connector.connect(${organizationName}::${domainName})
connector.run`
}
